// extracted by mini-css-extract-plugin
export var cartContainer = "_n8-4";
export var gray = "_n8-1";
export var itemContainer = "_n8-2";
export var itemDetails = "_n8-3";
export var strong = "_n8-0";